import React from 'react';
import { DatePicker } from 'antd';
import { SignUpFormItemSuperAdmin } from 'store/ducks/Global/types';

const signUpSuperUsersFormItems: SignUpFormItemSuperAdmin[] = [
  {
    type: 'email',
    label: 'Email Address',
    name: 'email',
    rules: [
      {
        required: true
      }
    ]
  },
  {
    type: 'password',
    label: 'Password',
    name: 'password',
    rules: [
      {
        required: true
      }
    ]
  },
  {
    type: 'custom',
    label: 'Deactivation Date',
    name: 'deactivation_date',
    render: () => <DatePicker />
  }
];

export default signUpSuperUsersFormItems;
